export default __webpack_public_path__ + "276353172975d1f14df00c672116a853.svg";